(function () {
  if (window.JD1GroupedProductsLoaded) return;
  window.JD1GroupedProductsLoaded = true;

  function initGroupedProducts(root) {
    root = root || document;
    var sliders = root.querySelectorAll('[data-jd1-grouped-products]');

    sliders.forEach(function (slider) {
      if (slider.dataset.initialized === 'true') return;

      var track = slider.querySelector('[data-jd1-grouped-track]');
      var prev = slider.querySelector('[data-jd1-grouped-prev]');
      var next = slider.querySelector('[data-jd1-grouped-next]');
      if (!track || !prev || !next) return;

      slider.dataset.initialized = 'true';
      var resizeFrame = 0;

      function getStep() {
        var item = track.querySelector('.jd1-grouped-products__item');
        if (!item) return 60;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 10) || 10;
        return item.offsetWidth + gap;
      }

      function updateArrows() {
        resizeFrame = 0;
        var hasOverflow = track.scrollWidth > track.clientWidth + 1;
        slider.classList.toggle('has-overflow', hasOverflow);
        prev.disabled = !hasOverflow || track.scrollLeft <= 1;
        next.disabled = !hasOverflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }

      function scheduleUpdate() {
        if (!resizeFrame) resizeFrame = window.requestAnimationFrame(updateArrows);
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
      });
      track.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });

      updateArrows();
    });
  }

  window.JD1InitGroupedProducts = initGroupedProducts;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGroupedProducts(document);
    }, { once: true });
  } else {
    initGroupedProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initGroupedProducts(event.target);
  });
})();

/* Restore collection position after returning from a product page.
   This part runs only on collection pages. */
(function () {
  if (window.JD1CollectionScrollRestoreLoaded) return;
  if (!/^\/collections\//.test(window.location.pathname)) return;
  window.JD1CollectionScrollRestoreLoaded = true;

  var STORAGE_KEY = 'jd1CollectionReturnState';
  var MAX_AGE = 30 * 60 * 1000;
  var productPathRegex = /^\/products\//;
  var restoreTimer = null;
  var restoredOnce = false;

  function isProductUrl(href) {
    if (!href) return false;
    try {
      return productPathRegex.test(new URL(href, window.location.origin).pathname);
    } catch (error) {
      return false;
    }
  }

  function currentCollectionKey() {
    return window.location.pathname + window.location.search;
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function getProductHandleFromHref(href) {
    if (!href) return null;
    try {
      var parts = new URL(href, window.location.origin).pathname.split('/').filter(Boolean);
      var productIndex = parts.indexOf('products');
      return productIndex !== -1 ? parts[productIndex + 1] || null : null;
    } catch (error) {
      return null;
    }
  }

  function findCardFromLink(link) {
    if (!link || !link.closest) return null;
    return link.closest('.product-card, .product-column, .usf-grid__item, .usf-sr-product, [data-product-id], [data-product_handle], [data-product-handle]');
  }

  function getCardProductId(card) {
    if (!card) return null;
    var node = card.matches('[data-product-id]') ? card : card.querySelector('[data-product-id]');
    return node ? node.getAttribute('data-product-id') : null;
  }

  function getCardProductHandle(card, link) {
    if (card) {
      var node = card.matches('[data-product-handle], [data-product_handle]')
        ? card
        : card.querySelector('[data-product-handle], [data-product_handle]');
      if (node) return node.getAttribute('data-product-handle') || node.getAttribute('data-product_handle');
    }
    return link ? getProductHandleFromHref(link.href) : null;
  }

  function saveState(link) {
    if (link && !isProductUrl(link.href)) return;
    var card = findCardFromLink(link);
    var state = {
      collectionUrl: currentCollectionKey(),
      scrollY: getScrollY(),
      productId: getCardProductId(card),
      productHandle: getCardProductHandle(card, link),
      timestamp: Date.now()
    };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (error) {}
  }

  function getSavedState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function clearSavedState() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (error) {}
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function findTargetCard(state) {
    if (!state) return null;
    if (state.productId) {
      var byId = document.querySelector('[data-product-id="' + cssEscape(state.productId) + '"]');
      if (byId) return byId.closest('.product-card, .product-column, .usf-grid__item, .usf-sr-product') || byId;
    }
    if (state.productHandle) {
      var handle = cssEscape(state.productHandle);
      var byHandle = document.querySelector('[data-product-handle="' + handle + '"], [data-product_handle="' + handle + '"], a[href*="/products/' + handle + '"]');
      if (byHandle) return byHandle.closest('.product-card, .product-column, .usf-grid__item, .usf-sr-product') || byHandle;
    }
    return null;
  }

  function isCollectionReady() {
    return Boolean(document.querySelector('#usf_container .usf-results, #usf_container .usf-grid__item, #ProductsList .product-card, #ProductGridContainer .product-card, .product-card'));
  }

  function restoreState() {
    if (restoredOnce) return;
    var state = getSavedState();
    if (!state || state.collectionUrl !== currentCollectionKey()) return;
    if (Date.now() - state.timestamp > MAX_AGE) {
      clearSavedState();
      return;
    }

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var attempts = 0;
    var maxAttempts = 40;
    var targetY = parseInt(state.scrollY, 10) || 0;

    function attemptRestore() {
      attempts += 1;
      var targetCard = findTargetCard(state);
      if (targetCard) {
        targetCard.scrollIntoView({ block: 'center', behavior: 'auto' });
        restoredOnce = true;
        return;
      }

      var docHeight = Math.max(
        document.body ? document.body.scrollHeight : 0,
        document.documentElement ? document.documentElement.scrollHeight : 0
      );
      if (targetY > 0 && isCollectionReady() && docHeight >= targetY + window.innerHeight) {
        window.scrollTo({ top: targetY, left: 0, behavior: 'auto' });
        restoredOnce = true;
        return;
      }

      if (attempts < maxAttempts) {
        window.setTimeout(attemptRestore, 250);
      } else {
        restoredOnce = true;
      }
    }

    window.setTimeout(attemptRestore, 300);
  }

  function scheduleRestore() {
    window.clearTimeout(restoreTimer);
    restoreTimer = window.setTimeout(restoreState, 120);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
    if (link) saveState(link);
  }, true);
  window.addEventListener('pagehide', function () { saveState(); });
  window.addEventListener('beforeunload', function () { saveState(); });
  window.addEventListener('pageshow', scheduleRestore);
  document.addEventListener('DOMContentLoaded', scheduleRestore);
  document.addEventListener('collection:rerendered', scheduleRestore);

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      if (getSavedState() && !restoredOnce) scheduleRestore();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
